import { render } from "./TransferToSurvey.vue?vue&type=template&id=022424af&ts=true"
import script from "./TransferToSurvey.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransferToSurvey.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/connect-flow/components/flow/nodes/TransferToSurvey.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "022424af"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('022424af', __exports__)) {
    api.reload('022424af', __exports__)
  }
  
  module.hot.accept("./TransferToSurvey.vue?vue&type=template&id=022424af&ts=true", () => {
    api.rerender('022424af', render)
  })

}


export default __exports__